// kycStatus from Profile/Get and KYC/DocumentDetails — colors as per the flow guide
export const KYC_STATUS = {
  1: { text: "NOT APPLIED", pill: "pill-pending" },
  2: { text: "APPLIED", pill: "pill-info" },
  3: { text: "COMPLETED", pill: "pill-success" },
  4: { text: "RE-KYC", pill: "pill-pending" },
  5: { text: "REJECTED", pill: "pill-failed" },
};

// `text` (e.g. kycStatusText) is used only for an unknown status
export default function KycStatusPill({ status, text }) {
  const s = KYC_STATUS[status];
  return (
    <span className={`pill ${s?.pill || "pill-neutral"}`}>
      {s?.text || text || "—"}
    </span>
  );
}
